import { useState, useEffect } from "react";
import AdminTabs from "../adminTabs";
import ClientModal from "./clientModal";
import PutAPI from "../../APICalls/PutAPI";
import PostAPI from "../../APICalls/PostAPI";
import GetAPI from "../../APICalls/GetQuery";
import { ThreeCircles } from "react-loader-spinner";

const CorporateOnboarding = () => {
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [menuType, setMenuType] = useState("");
  const [clients, setClients] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  let environment = process.env.REACT_APP_NODE_ENV;

  let corporate;
  if (environment.toUpperCase() === "PRODUCTION") {
    corporate = process.env.REACT_APP_PROD_CORPORATE;
  } else {
    corporate = process.env.REACT_APP_DEV_CORPORATE;
  }

  const menuTypeOptions = ["Breakfast", "Lunch", "Snacks", "Dinner"];

  useEffect(() => {
    getClientsData();
  }, []);

  const getClientsData = async () => {
    const QUERY_PARAMS = { status: "APPROVED", type: "CLIENT" };
    GetAPI(corporate, QUERY_PARAMS)
      .then((response) => {
        if (response.data.statusCode === 200) {
          setClients(response.data.body);
        } else {
          alert(`Unable to get all clients. Please try again!!!`);
        }
      })
      .catch((e) => {
        console.error(e);
        alert(`Unable to get all clients. Please try again!!!`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClientData = async (method, data) => {
    setLoading(true);

    const APIFunc = method.toLowerCase() === "post" ? PostAPI : PutAPI;

    try {
      const res = await APIFunc(corporate, data);
      if (res?.data?.statusCode === 200) {
        alert("Successfully updated!");
        getClientsData();
      } else {
        alert("Failed to update!");
      }
    } catch (e) {
      console.error(e);
      alert("Failed to update!");
    } finally {
      setLoading(false);
      setShowModal(false);
      setSelectedClient(null);
    }
  };

  const filteredClients = clients.filter((client) => {
    const matchesSearch = client.clientName
      .toLowerCase()
      .includes(search.toLowerCase());
    const matchesMenuType = menuType
      ? client.menuTypes.includes(menuType)
      : true;
    return matchesSearch && matchesMenuType;
  });

  return (
    <div>
      <AdminTabs >
        <>
          <div className="container py-4">
            {loading && (
              <div className="spinnerContainer">
                <div className="spinner">
                  <ThreeCircles
                    color="blue"
                    height={110}
                    width={110}
                    ariaLabel="three-circles-rotating"
                  />
                </div>
              </div>
            )}
            <ClientModal
              isOpen={showModal}
              onClose={() => {
                setShowModal(false);
                setSelectedClient(null);
              }}
              getClients={getClientsData}
              type={selectedClient ? "edit" : "add"}
              clientData={selectedClient}
              handleClientData={handleClientData}
            />

            <div className="d-flex justify-content-between align-items-start mb-3 ">
              <div className="d-flex gap-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Client"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />

                <select
                  className="form-select"
                  value={menuType}
                  onChange={(e) => setMenuType(e.target.value)}
                >
                  <option value="">All Menu Types</option>
                  {menuTypeOptions.map((type, idx) => (
                    <option key={idx} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>

              <button
                className="btn btn-primary"
                onClick={() => {
                  setSelectedClient(null);
                  setShowModal(true);
                }}
                disabled={loading}
              >
                Add New Client
              </button>
            </div>
            <div
              style={{
                maxHeight: "65vh",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <div className="row g-3">
                {filteredClients.map((client, index) => (
                  <div key={index} className="col-md-4">
                    <div className="card h-100 shadow-sm">
                      <div className="card-body d-flex flex-column justify-content-between">
                        <div>
                          <h5 className="card-title">{client.clientName}</h5>
                          <ul className="list-group list-group-flush mb-3">
                            {client.menuTypes.map((type, idx) => (
                              <li
                                key={idx}
                                className="list-group-item d-flex justify-content-between align-items-center"
                              >
                                {type}
                              </li>
                            ))}
                          </ul>
                        </div>
                        <button
                          className="btn btn-outline-primary"
                          onClick={() => {
                            setSelectedClient(client);
                            setShowModal(true);
                          }}
                        >
                          View Client
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      </AdminTabs>
    </div>
  );
};

export default CorporateOnboarding;
